import * as React from 'react';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { getUiBrowser } from '@/redux/modules/browser';
import { useAppSelector } from '@/redux/hooks';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import styled from 'styled-components';

type Props = {};

// eslint-disable-next-line no-empty-pattern
const BannerOutdatedBrowser = ({}: Props) => {
    const { isOutdated, majorVersion, name } = useAppSelector(getUiBrowser);
    if (!isOutdated) {
        return null;
    }

    return (
        <StyledBannerOutdated>
            <StyledNotificationMessage>
                <StyledMessageStatus>
                    <StyledExclamationIcon icon={faExclamationCircle} />
                </StyledMessageStatus>
                <StyledMessageBody>
                    <StyledMessageHeadline>
                        <FormattedMessage
                            id="did_you_know_that_your_web_browser"
                            values={{ formalName: <FormattedMessage id={name || '?'} />, majorVersion }}
                        />
                    </StyledMessageHeadline>
                    <div>
                        <FormattedMessage
                            id="browsers_for_best_experience"
                            values={{
                                chrome: (
                                    <Link rel="noopener" target="_blank" to="https://www.google.com/chrome/">
                                        <FormattedMessage id="chrome" />
                                    </Link>
                                ),
                                edge: (
                                    <Link rel="noopener" target="_blank" to="https://www.microsoft.com/edge">
                                        <FormattedMessage id="edge" />
                                    </Link>
                                ),
                                firefox: (
                                    <Link rel="noopener" target="_blank" to="https://www.mozilla.org/firefox/new/">
                                        <FormattedMessage id="firefox" />
                                    </Link>
                                ),
                            }}
                        />
                    </div>
                </StyledMessageBody>
            </StyledNotificationMessage>
        </StyledBannerOutdated>
    );
};

export default BannerOutdatedBrowser;

const StyledBannerOutdated = styled.div`
    width: 100%;
    left: 0;
    top: 0;
    z-index: 100;
    border-top: 0;
`;

const StyledNotificationMessage = styled.div`
    width: 100%;
    padding: 10px 20px;
    display: flex;
    flex-direction: row;
    background-color: ${({ theme }) => theme.colors.beige100};
    box-shadow: 0 0 5px ${({ theme }) => theme.colors.shadow200} inset;
    margin: 0;
    position: relative;
    overflow: hidden;
    align-items: center;
`;

const StyledMessageStatus = styled.div`
    flex: 0 0 auto;
    color: ${({ theme }) => theme.colors.red300};
    font-size: 36px;
    margin-right: 20px;
`;

const StyledExclamationIcon = styled(FontAwesomeIcon)`
    height: 36px;
    width: 36px;
`;

const StyledMessageBody = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const StyledMessageHeadline = styled.span`
    font-family: ${({ theme }) => theme.typography.fontPrimaryStrong};
    letter-spacing: 1px;
    color: ${({ theme }) => theme.colors.red300};
`;
